/**
 * @generated SignedSource<<3b780e71c0cf682ec94d3c51e9f1aedc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteIntegrationInput = {
  id: any;
};
export type PagerDutyIntegrationDeleteIntegrationMutation$variables = {
  input: DeleteIntegrationInput;
};
export type PagerDutyIntegrationDeleteIntegrationMutation$data = {
  readonly deleteIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type PagerDutyIntegrationDeleteIntegrationMutation = {
  response: PagerDutyIntegrationDeleteIntegrationMutation$data;
  variables: PagerDutyIntegrationDeleteIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PagerDutyIntegrationDeleteIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PagerDutyIntegrationDeleteIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "80a4a4e10cc47a69ee90fae623f09198",
    "id": null,
    "metadata": {},
    "name": "PagerDutyIntegrationDeleteIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation PagerDutyIntegrationDeleteIntegrationMutation(\n  $input: DeleteIntegrationInput!\n) {\n  deleteIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "9443dffb15f8637dcf5c13ebe8161938";

export default node;
